
import { 
  IonButtons,
  IonButton,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonTitle,
  IonToolbar,
  modalController,
  alertController } from "@ionic/vue";
import { defineComponent } from "vue";
import { close, calendar, save} from "ionicons/icons";
import { useStore } from "@/store";
import moment from "moment";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "PromiseDateModal",
  props: [ 'item' , 'items'],
  computed: {
    ...mapGetters({
      jobTotal: 'job/getTotal',
      getSelectedItemsToUpdatePromiseDate: 'order/getSelectedItemsToUpdatePromiseDate',
    }),
    disableUpdate(): boolean {
      return this.promisedDatetime === '' || (this.item && this.item.promisedDatetime && moment(this.item.promisedDatetime, "YYYY-MM-DD hh:mm:ss.SSS").format("YYYY-MM-DD") === this.promisedDatetime) ;
    }
  },
  methods: {
    closeModal() {
      modalController.dismiss({ dismissed: true });
    },
    async saveAlert() {
      const alert = await alertController.create({
        header: this.$t("Update promise date"),
        message: this.$t(
          "Are you sure you want to update the promise date for these orders?"
        ),
        buttons: [
            {
              text: this.$t("Cancel"),
            },
            {
              text: this.$t("Confirm"),
              handler: () => {
                (this.item ? this.updatePromisedDateItem() : this.updatePromiseDateItems()).then(() => {
                    this.closeModal()
                  })
                }
              }
            ],
      });
      return alert.present();
    },
    async updatePromiseDateItems() {
      // TODO Handle timezone
      const promisedDatetime = moment(this.promisedDatetime).endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS")
      const items = this.getSelectedItemsToUpdatePromiseDate(promisedDatetime);
      const json = JSON.stringify(items);
      const blob = new Blob([json], { type: 'application/json'});
      const formData = new FormData();
      const fileName = "UpdatePromiseDateItems_" + Date.now() +".json";
      formData.append("uploadedFile", blob, fileName);
      formData.append("configId", "MDM_UPD_ORD_ITM_JSON");
      return this.store.dispatch("order/updatePromiseDateItems", {
          headers: {
              'Content-Type': 'multipart/form-data;'
          },
          data: formData
      })
    },
    async updatePromisedDateItem () {
      const promisedDatetime = moment(this.promisedDatetime).endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS")
      return this.store.dispatch("order/updatePromiseDateItem", {
          orderId: this.item.orderId,
          orderItemSeqId: this.item.orderItemSeqId,
          promisedDatetime: promisedDatetime
        })
    },

  },
  beforeMount() {
    // TODO Set current date
    if (this.item && this.item.promisedDatetime) this.promisedDatetime = moment(this.item.promisedDatetime).format("YYYY-MM-DD")
  },
  setup() {
   const store = useStore();
    return {
      close,
      calendar,
      save,
      store
    };
  },
  components: { 
    IonButtons,
    IonButton,
    IonContent,
    IonFab,
    IonFabButton,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonTitle,
    IonToolbar 
    },
    data () {
      return {
        promisedDatetime : ''
      }
    }
});
